



// import React, { useContext } from "react";
// import Rightcontainer from "../Components/Rightcontainer";
// import { LanguageContext } from "../Components/LanguageContext";
// import { RiTelegramFill, RiWhatsappFill, RiCustomerService2Fill } from "react-icons/ri";
// import { BsShieldCheck, BsClockHistory, BsArrowRightShort } from "react-icons/bs";
// // import "./Support.css";

// const Support = () => {
//   const { language } = useContext(LanguageContext);

//   // Get settings from localStorage safely
//   const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

//   const translations = {
//     hi: {
//       help: "24/7 सहायता केंद्र",
//       sub: "क्या आपको कोई समस्या है? हम सहायता के लिए यहाँ हैं",
//       contact: "संपर्क माध्यम चुनें",
//       telegram: "टेलीग्राम सपोर्ट",
//       whatsapp: "व्हाट्सएप चैट",
//       quick: "त्वरित प्रतिक्रिया (2-5 मिनट)",
//       instant: "इंस्टेंट चैट सहायता",
//       secure: "100% सुरक्षित और गोपनीय सहायता",
//       online: "ऑनलाइन एजेंट उपलब्ध हैं",
//     },
//     en: {
//       help: "24/7 Support Center",
//       sub: "Having an issue? Our team is active & ready to assist",
//       contact: "Choose a contact channel",
//       telegram: "Telegram Support",
//       whatsapp: "WhatsApp Chat",
//       quick: "Quick Response (2-5 mins)",
//       instant: "Instant live chat support",
//       secure: "100% Secure & Confidential Support",
//       online: "Live Agents Online",
//     },
//   };

//   const t = translations[language] || translations.en;

//   const telegramLink = siteSetting.supportTelegram || "https://t.me/";
//   const whatsappLink = siteSetting.whatsappSupport || "https://wa.me/";

//   return (
//     <div className="sa-support-wrapper leftContainer mt-5 pt-5">
//       <div className="sa-support-container mb-5">
        
//         {/* Header Hero Card */}
//         <div className="sa-support-hero">
//           <div className="sa-hero-glow"></div>
          
//           <div className="sa-hero-top">
//             <div className="sa-online-status">
//               <span className="sa-pulse-dot"></span>
//               <span>{t.online}</span>
//             </div>
//           </div>

//           <div className="sa-support-header">
//             <div className="sa-help-icon-wrap">
//               <RiCustomerService2Fill className="sa-main-icon" />
//             </div>
//             <h1 className="sa-support-title">{t.help}</h1>
//             <p className="sa-support-sub">{t.sub}</p>
//           </div>
//         </div>

//         {/* Channels Section */}
//         <div className="sa-support-body">
//           <div className="sa-section-header">
//             <h3 className="sa-section-title">{t.contact}</h3>
//             <span className="sa-time-badge">
//               <BsClockHistory /> 24/7 Active
//             </span>
//           </div>

//           <div className="sa-grid-options">
            
//             {/* Telegram Card */}
//             <a
//               href={telegramLink}
//               className="sa-contact-card telegram-theme"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <div className="sa-card-glow"></div>
//               <div className="sa-card-left">
//                 <div className="sa-card-icon">
//                   <RiTelegramFill />
//                 </div>
//                 <div className="sa-card-info">
//                   <h4>{t.telegram}</h4>
//                   <span>{t.quick}</span>
//                 </div>
//               </div>
//               <BsArrowRightShort className="sa-card-arrow" />
//             </a>

//             {/* WhatsApp Card */}
//             <a
//               href={whatsappLink}
//               className="sa-contact-card whatsapp-theme"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <div className="sa-card-glow"></div>
//               <div className="sa-card-left">
//                 <div className="sa-card-icon">
//                   <RiWhatsappFill />
//                 </div>
//                 <div className="sa-card-info">
//                   <h4>{t.whatsapp}</h4>
//                   <span>{t.instant}</span>
//                 </div>
//               </div>
//               <BsArrowRightShort className="sa-card-arrow" />
//             </a>

//           </div>

//           {/* Secure Trust Box */}
//           <div className="sa-secure-box">
//             <BsShieldCheck className="sa-shield" />
//             <span>{t.secure}</span>
//           </div>
//         </div>

//       </div>

//       <div className="rightContainer hidden-mobile">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;


import React, { useContext } from "react";
import { Link } from "react-router-dom";
import {
  Headphones,
  Send,
  MessageCircle,
  ShieldCheck,
  Clock,
  ChevronRight,
  Sparkles,
  Zap,
  Radio
} from "lucide-react";
import {
  BsArrowRightShort,
  BsTelegram,
  BsWhatsapp,
  BsShieldCheck,
  BsHeadset,
  BsClockHistory,
  BsPatchCheckFill,
} from "react-icons/bs";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
// import "./Support.css";

const Support = () => {
  const { language } = useContext(LanguageContext);

  // Get settings from localStorage safely
  const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      help: "24/7 सहायता केंद्र",
      sub: "क्या आपको कोई समस्या है? हम सहायता के लिए यहाँ हैं",
      contact: "संपर्क माध्यम चुनें",
      telegram: "टेलीग्राम सपोर्ट",
      whatsapp: "व्हाट्सएप चैट",
      quick: "त्वरित प्रतिक्रिया (2-5 मिनट)",
      instant: "इंस्टेंट चैट सहायता",
      secure: "100% सुरक्षित और गोपनीय सहायता",
      online: "ऑनलाइन एजेंट उपलब्ध हैं",
    },
    en: {
      help: "24/7 Support Center",
      sub: "Having an issue? Our team is active & ready to assist",
      contact: "Choose a contact channel",
      telegram: "Telegram Support",
      whatsapp: "WhatsApp Chat",
      quick: "Quick Response (2-5 mins)",
      instant: "Instant live chat support",
      secure: "100% Secure & Confidential Support",
      online: "Live Agents Online",
    },
  };

  const t = translations[language] || translations.en;

  const telegramLink = siteSetting.supportTelegram || "https://t.me/";
  const whatsappLink = siteSetting.whatsappSupport || "https://wa.me/";

  return (
    <div className="sa-support-wrapper leftContainer mt-5 pt-5">
      {/* Background Ambient Mesh Lights */}
      <div className="support-ambient glow-1"></div>
      <div className="support-ambient glow-2"></div>
      <div className="support-ambient glow-3"></div>

      <div className="sa-support-container mb-5">
        
        {/* Header Hero Card */}
        <div className="sa-support-hero">
          <div className="sa-hero-bg-glow"></div>
          
          <div className="sa-hero-top">
            <div className="sa-online-status">
              <span className="sa-pulse-dot"></span>
              <Radio size={14} className="sa-radio-icon" />
              <span>{t.online}</span>
            </div>
            <div className="sa-badge-pill">
              <Sparkles size={14} className="sparkle-icon" />
              <span>24/7 VIP Help</span>
            </div>
          </div>

          <div className="sa-support-header">
            <div className="sa-help-icon-wrap">
              <Headphones size={32} className="sa-main-icon" />
            </div>
            <div className="sa-header-text">
              <h1 className="sa-support-title">{t.help}</h1>
              <p className="sa-support-sub">{t.sub}</p>
            </div>
          </div>
        </div>

        {/* Channels Section */}
        <div className="sa-support-body">
          <div className="sa-section-header">
            <h3 className="sa-section-title">{t.contact}</h3>
            <span className="sa-time-badge">
              <Clock size={14} /> 24/7 Active
            </span>
          </div>

          <div className="sa-grid-options">
            
            {/* Telegram Card */}
            <a
              href={telegramLink}
              className="sa-contact-card telegram-theme"
              target="_blank"
              rel="noreferrer"
            >
              <div className="sa-card-glow"></div>
              <div className="sa-card-left">
                <div className="sa-card-icon telegram">
                  <Send size={22} className="card-icon-anim" />
                </div>
                <div className="sa-card-info">
                  <div className="sa-card-title-row">
                    <h4>{t.telegram}</h4>
                    <span className="sa-speed-pill cyan">
                      <Zap size={12} /> Fast
                    </span>
                  </div>
                  <span className="sa-card-sub">{t.quick}</span>
                </div>
              </div>
              <div className="sa-arrow-circle">
                <ChevronRight size={18} className="sa-card-arrow" />
              </div>
            </a>

            {/* WhatsApp Card */}
            <a
              href={whatsappLink}
              className="sa-contact-card whatsapp-theme"
              target="_blank"
              rel="noreferrer"
            >
              <div className="sa-card-glow"></div>
              <div className="sa-card-left">
                <div className="sa-card-icon whatsapp">
                  <MessageCircle size={22} className="card-icon-anim" />
                </div>
                <div className="sa-card-info">
                  <div className="sa-card-title-row">
                    <h4>{t.whatsapp}</h4>
                    <span className="sa-speed-pill green">
                      <Zap size={12} /> Instant
                    </span>
                  </div>
                  <span className="sa-card-sub">{t.instant}</span>
                </div>
              </div>
              <div className="sa-arrow-circle">
                <ChevronRight size={18} className="sa-card-arrow" />
              </div>
            </a>
  {/* Live Chat Card */}
<Link
  to="/support-chat"
  className="sa-contact-card chat-theme"
  style={{ textDecoration: "none" }}
>
  <div className="sa-card-glow"></div>

  <div className="sa-card-left">
    <div className="sa-card-icon chat">
      <BsHeadset size={22} className="card-icon-anim" />
    </div>

    <div className="sa-card-info">
      <div className="sa-card-title-row">
        <h4>Live Support Chat</h4>

        <span className="sa-speed-pill blue">
          <Zap size={12} /> Online
        </span>
      </div>

      <span className="sa-card-sub">
        Chat with our support executives in real-time
      </span>
    </div>
  </div>

  <div className="sa-arrow-circle">
    <ChevronRight size={18} className="sa-card-arrow" />
  </div>
</Link>
          </div>

          {/* Secure Trust Box */}
          <div className="sa-secure-box">
            <ShieldCheck size={20} className="sa-shield" />
            <span>{t.secure}</span>
          </div>
        </div>

      </div>

      <div className="rightContainer hidden-mobile">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;